import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { DatesParentDataType } from "../../../cxone-etl-reporting-set.model";

@Component({
    selector: 'cv-cxone-reporting-set-coalesce-field',
    templateUrl: './cxone-reporting-set-coalesce-field.component.html',
    styleUrls: ['./cxone-reporting-set-coalesce-field.component.scss']
})

export class CxoneReportingSetCoalesceFieldComponent implements OnInit {

    @Output() back = new EventEmitter();
    @Output() addChilds = new EventEmitter();
    @Output() editExistItem = new EventEmitter();
    @Output() formChanged = new EventEmitter();
    @Input() set parentData(data) {
        this._parentData = data;
        this._parentData.isValid = data.childs.length > 0;
    }

    _parentData: DatesParentDataType;
    showFields = true;
    public addFieldPlaceholderText = '';
    public coalesceForm = this.fb.group({
        addFields: this.fb.array([]),
    });

    constructor(
        private cvLocalizationService: CVLocalizationService,
        private fb: FormBuilder,
        private el: ElementRef
    ) { }

    get addFields() {
        return this.coalesceForm.get("addFields") as FormArray;
    }

    get formControlCount() {
        return this.addFields.length;
    }

    get parentData() {
        return this._parentData;
    }

    async ngOnInit() {
        await this.loadLocalization();
        this.addFields.push(
            this.fb.group({
                nestedDataFields: new FormArray([]), // For nested DataField components
            })
        );
        if (this.parentData) {
            this.parentData.isValid = this.parentData.childs.length > 0;
        }
    }

    async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection('ETL_Reporting_Set');
        }
        catch {
            console.log('Failed to load localization for ETL_Reporting_Set');
        }
        finally {
            this.addFieldPlaceholderText = this.getLocalizationString("Input_Field_Placeholder", "Add input");
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText("ETL_Reporting_Set", key, defaultValue);
        return baseString;
    }

    handleIcons(index: number) {
        const addIcon = this.el.nativeElement.querySelector(`.add-icon-${index}`);
        const nextAddIcon = this.el.nativeElement.querySelector(`.add-icon-${index + 1}`);
        const editIcon = this.el.nativeElement.querySelector(`.edit-icon-${index}`);
        const nextEditIcon = this.el.nativeElement.querySelector(`.edit-icon-${index + 1}`);
        addIcon.style.display = 'none';
        editIcon.style.display = 'block';
        nextAddIcon.style.display = 'none';
        nextEditIcon.style.display = 'block';
    }

    addNewField(index: number = 0) {
        this.showFields = false;
        this._parentData.isValid = this.parentData.childs.length > 0;
        this.formChanged.emit(this._parentData);
        this.addChilds.emit(this.parentData);
    }

    public goBack(): void {
        this.back.emit(this.parentData);
    }

    editExist(item) {
        this.editExistItem.emit(item);
    }

}